import React from "react";
import { motion } from "framer-motion";
import { Landmark, Building2, HeartPulse, GraduationCap, ShoppingCart, Gamepad2, Home, Wallet, Banknote } from "lucide-react";

const industries = [
  { icon: Wallet, name: "FinTech" },
  { icon: ShieldSafe, name: "Insurance" },
  { icon: Gamepad2, name: "Gaming" },
  { icon: GraduationCap, name: "EdTech" },
  { icon: ShoppingCart, name: "E-commerce" },
  { icon: Banknote, name: "Finance" },
  { icon: Building2, name: "Consumer Brands" },
  { icon: Home, name: "Real Estate" },
  { icon: HeartPulse, name: "Healthcare" },
];

function ShieldSafe(props) {
  return <Landmark {...props} />;
}

export default function Industries() {
  return (
    <section className="relative py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="eyebrow">Industries Served</span>
            <h2 className="mt-6 text-3xl md:text-5xl font-semibold max-w-xl">Powering growth across <span className="text-gold-gradient">every category.</span></h2>
          </div>
          <p className="text-white/55 max-w-sm">From regulated finance to fast-moving consumer brands, our playbook adapts to your category.</p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-9 gap-3">
          {industries.map((it, i) => (
            <motion.div
              key={it.name}
              initial={{opacity:0, y:16}}
              whileInView={{opacity:1, y:0}}
              viewport={{once:true}}
              transition={{duration:0.5, delay: i*0.04, ease:[0.16,1,0.3,1]}}
              className="group glass rounded-xl p-4 flex flex-col items-center gap-2 hover:border-[#C9A227]/40 transition-colors"
            >
              <it.icon size={20} className="text-[#F4D983] group-hover:scale-110 transition-transform" />
              <div className="text-xs text-white/75 text-center">{it.name}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
